import type { UploadedVideoSource } from 'components/chat-components/AgentMessage.types'
import type { MuxPlaybackEmbed } from 'utils/videoUrlResolver'

const normalizePlaybackUrl = (url: string): string => {
  return url.split('?')[0]
}

export const resolveMuxForVideoArtifact = (
  videoUrl: string,
  videoSources: UploadedVideoSource[] | undefined,
  fallbackMux: MuxPlaybackEmbed | undefined
): MuxPlaybackEmbed | undefined => {
  if (!videoSources?.length) {
    return fallbackMux
  }

  const normalized = normalizePlaybackUrl(videoUrl)
  const matched = videoSources.find(source => {
    const candidates = [source.videoUrl, source.playbackUrl].flatMap(url => (url ? [url] : []))
    return candidates.some(url => normalizePlaybackUrl(url) === normalized)
  })

  if (matched) {
    return matched.mux
  }

  // Prefer no mux over the wrong primary player when the artifact is a different file.
  if (videoSources.length > 1) {
    return undefined
  }

  return fallbackMux
}
